module.exports = {"id":"236610","name":"Moise Kean","rating":"71","photo":"./data/images/photos/3/236610.png","club":{"name":"Hellas Vérone","logo":"./data/images/clubs/HellasVerone.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MoiseKean0.json
// module id = 3071
// module chunks = 0